import { h } from "preact";
import { Trans } from "@lingui/react/macro";
import Config from "../../../../services/config";
import Vouchers from "../../../../services/vouchers";
import { Component } from "preact";

import * as I from "../../utils/icons";
import { VouchersPageEmbedded } from "./redeem-voucher";

export default class CreateVoucher extends Component {
    state = {
        phase: 'default' || 'loading' || 'success' || 'error',
        data: null
    }

    /**
     * @param {FormData} formData
     */
    onVoucherSubmit(formData) {
        const voucherApi = new Vouchers();
        voucherApi.createVoucher(parseFloat(formData.get("amount"))).then(success => {
            this.setState({ phase: 'success', data: success });
        }).catch(error => {
            this.setState({ phase: 'error', data: error });
        })
        this.setState({ phase: 'loading' });
    }

    render() {
        return <div class="grow w-full flex flex-col items-center pt-3 text-slate-800 bg-gradient-to-br from-fuchsia-300 to-blue-300">
            <div class="flex flex-col items-center w-full max-w-sm backdrop-blur-xl bg-white/50 rounded p-4 px-6">
                {this.state.phase == 'default' ? <CreateVoucherTemplate onSubmit={form => this.onVoucherSubmit(form)} />
                : this.state.phase == 'loading' ? <Loading />
                : this.state.phase == 'error' ? <ErrorPage data={this.state.data} />
                : this.state.phase == 'success' ? <SuccessPage data={this.state.data} onRepeat={() => this.setState({phase: "default"})} />
                : null}
            </div>
            {this.state.phase != 'default' ? null :
                <div class="flex flex-col items-center w-full max-w-sm backdrop-blur-xl bg-white/50 rounded p-4 px-2 mt-2">
                    <VouchersPageEmbedded />
                </div>}
        </div>
    }
}

function CreateVoucherTemplate({ onSubmit }) {
    return <form class="flex flex-col items-center gap-2 w-full" onSubmit={e => { e.preventDefault(); onSubmit(new FormData(e.target)) }}>
        <div class="w-full text-4xl font-light pb-2"><Trans>Crate Voucher</Trans></div>
        <div class="w-full">
            <div class="text-sm"><Trans>Amount</Trans></div>
            <div class="h-8 w-full flex">
                <input class="border h-full rounded-s bg-slate-100 border-slate-300 text-slate-800 py-2 px-3 w-16 text-base" disabled={true} value="ETB" />
                <input class="border border-l-0 h-full rounded-e bg-white border-slate-300 text-slate-950 py-2 px-3 text-base grow" required={true} name="amount" type="number" step="1" min="10" />
            </div>
        </div>
        <div class="w-full py-2 border-t border-b border-slate-950">
            <div class="text-base"><Trans>Rapid amounts</Trans></div>
            <div class="w-full flex justify-between flex-wrap gap-1">
                <RapidSelectButton target="amount" value={100} />
                <RapidSelectButton target="amount" value={500} />
                <RapidSelectButton target="amount" value={1000} />
                <RapidSelectButton target="amount" value={2000} />
                <RapidSelectButton target="amount" value={5000} />
            </div>
        </div>
        <div class="w-full py-2 flex justify-center">
            <button type="submit" class="mx-auto px-5 py-3 text-center rounded bg-emerald-600 text-slate-50 border-emerald-700 text-xl">
                <Trans>Crate Voucher</Trans>
            </button>
        </div>
    </form>;
}

function Loading() {
    return <div role="status" class="w-full flex flex-col items-center gap-4">
        <svg aria-hidden="true" class="w-32 h-32 text-white animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span class="text-4xl font-thin"><Trans>Please wait</Trans></span>
    </div>
}

function ErrorPage({data}) {
    return <div role="status" class="w-full flex flex-col items-center gap-4">
        <I.CircleXmark class="h-32 text-red-600" />
        <span class="text-4xl text-red-600 text-center"><Trans>Error</Trans></span>
        <ul class="list-disc">
            {data.errors.map(error => <li class="text-base">{error}</li>)}
        </ul>
    </div>
}

function SuccessPage({data, onRepeat}) {
    return <div role="status" class="w-full flex flex-col items-center gap-4">
        <I.CircleCheck class="h-32 text-green-500" />
        <span class="text-4xl text-green-500 text-center"><Trans>Voucher created</Trans></span>
        <span class="text-base"><Trans>Voucher Code</Trans>:</span>
        <span class="text-xl">{data.voucher}</span>
        <div class="flex items-center gap-2">
            <div class="bg-kobaaccent-600 text-white px-2 py-1 shadow-lg flex gap-1 justify-start items-center" onClick={e => navigator.clipboard.writeText(data.voucher)}>
                <I.CopyIcon class="h-4" /><span><Trans>Copy</Trans></span>
            </div>
            <div class="bg-blue-whale-800 text-white px-2 py-1 shadow-lg flex gap-1 justify-start items-center" onClick={onRepeat}>
                <I.RefreshIcon class="h-4" /><span><Trans>Repeat</Trans></span>
            </div>
        </div>
        <span class="text-sm pt-2 text-center">
            <Trans>Voucher codes are secret. Save this voucher code somewhere safe.</Trans>
            {" "}
            <Trans>If you lose the voucher code you won't be able to recover it</Trans>
        </span>
    </div>
}

function RapidSelectButton({ target, value }) {
    return <button
        class="flex items-center justify-center border rounded bg-slate-100 px-2 py-1 text-2xl"
        onClick={e => { e.target.closest('form').querySelector('[name="' + target + '"]').value = value }}
        type="button"
    >
        {value}
    </button>
}

